export const checkedBorderColor = (selectedKit: any, currentkit: any) => {
  return selectedKit === currentkit ? 'card text-center border-primary' : 'card text-center border-secondary';
};
